import React, { useState } from "react";

//Router
import { NavHashLink } from "react-router-hash-link";

//Icon
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faNewspaper } from "@fortawesome/free-solid-svg-icons";

//Social Icons
import { socialIcons } from "../../assets/socialIcons";

//Logo
import Logo from "../../assets/logo.png";

//Component
//--> Button
import { LinkBtn } from "../Button/Button";

export default function Header() {
  const [toggle, setToggle] = useState(false);

  return (
    <div className="Navigation">
      <div className="Top">
        <div className="Social">
          <FontAwesomeIcon
            style={{ borderLeft: "1px solid #005288" }}
            className="icon"
            icon={faNewspaper}
          />
        </div>
        <div className="marquee">
          <marquee>
            {/* Our CRM is underdevelopment or testing. It will be available soon
              meanwhile co-operate with us. Sorry for this inconvenience. */}
            We are Live now!
          </marquee>
        </div>
        <div className="Social">
          {socialIcons.map((icons, index) => {
            return index === 0 ? (
              <a
                href={icons.link}
                key={index}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  className="icon"
                  icon={icons.iconName}
                  style={{ borderLeft: "1px solid #005288" }}
                />
              </a>
            ) : (
              <a
                href={icons.link}
                key={index}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon className="icon" icon={icons.iconName} />
              </a>
            );
          })}
        </div>
      </div>
      <header className="header">
        <div className="Logo">
          <NavHashLink exact to="#Intro" smooth>
            <img src={Logo} alt="IMANCO Trading - Established Since 1976" />
          </NavHashLink>
        </div>
        <div className="title">
          IG AGENT
          {/* <span>M. Daniyal Malik .C</span> */}
        </div>
        <nav className={toggle ? "active" : ""}>
          <ul>
            <li>
              <NavHashLink
                activeClassName="selected"
                className="navlink"
                to="/#Intro"
                smooth
              >
                Home
              </NavHashLink>
            </li>
            <li>
              <NavHashLink
                activeClassName="selected"
                className="navlink"
                to="/#About"
                smooth
              >
                About
              </NavHashLink>
            </li>
            <li>
              <NavHashLink
                activeClassName="selected"
                className="navlink"
                to="/#Services"
                smooth
              >
                Services
              </NavHashLink>
            </li>
            {/* <li>
                <NavHashLink
                  activeClassName="selected"
                  className="navlink"
                  to="/#Pricing"
                  smooth
                >
                  Pricing
                </NavHashLink>
              </li> */}
            <li>
              <NavHashLink
                activeClassName="selected"
                className="navlink"
                to="/#Benefits-&-Improvements"
                smooth
              >
                Benefits & Improvements
              </NavHashLink>
            </li>
            <li>
              <NavHashLink
                activeClassName="selected"
                className="navlink"
                to="/#Contact"
                smooth
              >
                Contact
              </NavHashLink>
            </li>
            <div className="Auth">
              <LinkBtn path="/SignUp" classname="SignUp" label="Sign Up" />
              <LinkBtn path="/SignIn" classname="SignIn" label="Sign In" />
            </div>
          </ul>
        </nav>
        <div className="menu-toggle">
          <FontAwesomeIcon icon={faBars} onClick={() => setToggle(!toggle)} />
        </div>
      </header>
    </div>
  );
}
